import { render, staticRenderFns } from "./UserActions.vue?vue&type=template&id=fedc6164&scoped=true&"
import script from "./UserActions.vue?vue&type=script&lang=ts&"
export * from "./UserActions.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fedc6164",
  null
  
)

export default component.exports